<template>
  <div
    class="pagination-container form-group align-items-start justify-content-center"
    :class="{ 'pagination-container--disabled': disabled }"
    :style="{ '--apperances-color': color || 'var(--primary)' }"
  >
    <nav class="d-flex align-items-center mb-2">
      <ul class="pagination mb-0">
        <!-- Prev -->
        <li :class="['page-item', { disabled: disabled || currentPage === 1 }]">
          <a class="page-link px-3 px-md-4" @click="goToPage(currentPage - 1)">Prev</a>
        </li>

        <!-- Pages -->
        <li
          v-for="p in visiblePages"
          :key="p.key"
          :class="['page-item', { active: p.number === currentPage, disabled: disabled || p.disabled }]"
        >
          <a class="page-link" @click="!disabled && !p.disabled && goToPage(p.number)">
            {{ p.display }}
          </a>
        </li>

        <!-- Next -->
        <li :class="['page-item', { disabled: disabled || currentPage === totalPages }]">
          <a class="page-link px-3 px-md-4" @click="goToPage(currentPage + 1)">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>


export default {
  name: 'Pagination',
  props: {
    color: { type: String, required: false },
    totalPages: { type: Number, required: true },
    page: { type: Number, default: 1 },
    onChange: { type: Function, required: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    currentPage() {
      return this.page
    },
    visiblePages() {
      const pages = []
      const delta = 2

      const left = Math.max(1, this.currentPage - delta)
      const right = Math.min(this.totalPages, this.currentPage + delta)

      if (left > 1) pages.push({ key: 1, number: 1, display: 1 })
      if (left > 2) pages.push({ key: 'start-ellipsis', disabled: true, display: '...' })

      for (let i = left; i <= right; i++) {
        pages.push({ key: i, number: i, display: i })
      }

      if (right < this.totalPages - 1) pages.push({ key: 'end-ellipsis', disabled: true, display: '...' })
      if (right < this.totalPages) pages.push({ key: this.totalPages, number: this.totalPages, display: this.totalPages })

      return pages
    }
  },
  methods: {
    goToPage(page) {
      // Clicking the active page would push the same location and vue-router rejects with NavigationDuplicated
      if (this.disabled || page < 1 || page > this.totalPages || page === this.currentPage) return

      this.onChange(page)
    }
  }
}
</script>
<style scoped>
  .page-item {
    flex: 0 0 auto;
  }

  .page-link {
    color: var(--apperances-color) !important;
    white-space: nowrap;
  }

  .page-item.active .page-link {
    color: white !important;
    background-color: var(--apperances-color) !important;
    border-color: var(--apperances-color) !important;
  }

  .pagination-container--disabled {
    pointer-events: none;
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue